// Short for "html", useful for outputting HTML conditionally in LitElement templates.
const h = (condition, value, falseValue = '') =>
  condition ? (value 
    ? (typeof value === 'function' ? value() : value) 
    : condition
  ) : falseValue;

export default h;